import Dropdown from "../Dropdown/Dropdown";
import "./Search.scss";
import axios from "axios";
import {
  sortAlphabetically,
  isSubredditSearch,
  getURLParams,
} from "../../utils/helper";
import { BASE_URL } from "../../api/api";
import { useHistory } from "react-router-dom";
import { useState, useEffect } from "react";
import Trending from "../Trending/Trending";
import Autofill from "../Autofill/Autofill";
import { prepareTimeInterval } from "../../utils/helper";

const Search = ({
  timeInterval,
  setTimeInterval,
  setSearchTerm,
  postsAnalyzed,
  setPostsAnalyzed,
  subreddits,
  subredditSearch,
  className,
}) => {
  const [trendingData, setTrendingData] = useState({ sr: [], keywords: [] });
  const [displayedSearch, setDisplayedSearch] = useState("");
  const [autofill, setAutofill] = useState([]);
  const [placeholder, setPlaceholder] = useState("Enter a Subreddit");
  const history = useHistory();

  /**
   * Search & click handlers
   */

  const onClickHandler = (searchTerm, subredditSearch) => {
    const time = prepareTimeInterval(timeInterval);
    const n = postsAnalyzed.split(" ")[0];

    subredditSearch
      ? history.push(`/subreddit-analysis?sr=${searchTerm}&t=${time}&n=${n}`)
      : history.push(`/keyword-analysis?kw=${searchTerm}&t=${time}&n=${n}`);

    setDisplayedSearch("");
    setAutofill([]);

    // Note: needed to rerender after URL change while already on SubredditDashboard
    const urlParams = getURLParams(window.location.search);
    if (urlParams) setSearchTerm(urlParams.sr);
  };

  const srSearchHandler = (e) => {
    e.preventDefault();

    const search = e.target.search.value.toLowerCase().replace(/\s/g, "");
    if (!search) return;

    setSearchTerm(search);

    const time = prepareTimeInterval(timeInterval);
    const n = postsAnalyzed.split(" ")[0];
    history.push(`/subreddit-analysis?sr=${search}&t=${time}&n=${n}`);

    // resets
    e.target.reset();
    setDisplayedSearch("");
    setAutofill([]);
  };

  const keywordSearchHandler = (e) => {
    e.preventDefault();

    const search = e.target.search.value.toLowerCase();
    if (!search) return;

    // resets
    e.target.reset();
    setDisplayedSearch("");

    const time = prepareTimeInterval(timeInterval);
    const n = postsAnalyzed.split(" ")[0];
    history.push(`/keyword-analysis?kw=${search}&t=${time}&n=${n}`);
  };

  /**
   * Functions dealing with trending data & autofill
   */
  // TODO: add filters as URL params
  const getTrendingData = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/reddit/trending`);
      setTrendingData(res.data);
    } catch (error) {
      console.log("GET trending data error", error);
    }
  };

  const filterSubreddits = (currentSearch, arr) => {
    if (currentSearch === "") {
      setDisplayedSearch(currentSearch);
      setAutofill([]);
      return;
    }

    setDisplayedSearch(currentSearch);

    arr = arr.filter(
      (obj) =>
        obj.name.slice(0, currentSearch.length) === currentSearch.toLowerCase()
    );
    arr = sortAlphabetically(arr);
    setAutofill(arr.slice(0, 5));
  };

  useEffect(() => {
    history.location.pathname.length === 1 && getTrendingData();
  }, [history.location.pathname.length]);

  useEffect(() => {
    setPlaceholder(
      isSubredditSearch(subredditSearch) ? "Search subreddits..." : "Search keywords..."
    );
  }, [history.location.pathname.length, subredditSearch]);

  return (
    <form
      className={`${
        history.location.pathname.length === 1
          ? "searchbar"
          : className
      }`}
      onSubmit={
        isSubredditSearch(subredditSearch)
          ? srSearchHandler
          : keywordSearchHandler
      }
    >
      <div className="searchbar__wrapper">
        <div
          className={`searchbar__container ${
            history.location.pathname.length > 1 &&
            "searchbar__container--small"
          }`}
        >
          <p
            className={`searchbar__title ${
              history.location.pathname.length > 1 && "searchbar__title--small"
            }`}
          >
            {isSubredditSearch(subredditSearch) ? "r/" : "k/"}
          </p>
          <input
            type="text"
            className={`searchbar__search ${
              history.location.pathname.length > 1 && "searchbar__search--small"
            }`}
            name="search"
            placeholder={placeholder}
            value={displayedSearch}
            onChange={
              isSubredditSearch(subredditSearch)
                ? (e) => filterSubreddits(e.target.value, subreddits)
                : (e) => setDisplayedSearch(e.target.value)
            }
          />
        </div>
        {isSubredditSearch(subredditSearch) ? (
          <Autofill autofillArray={autofill} clickHandler={onClickHandler} />
        ) : null}
      </div>
      {history.location.pathname.length === 1 && (
        <>
          <Trending
            trendingData={
              subredditSearch ? trendingData.sr : trendingData.keywords
            }
            setSearchTerm={setSearchTerm}
            onClickHandler={onClickHandler}
            subredditSearch={subredditSearch}
          />
          <div className="searchbar__filters">
            <p className="searchbar__text">Filters:</p>
            <Dropdown
              genericState={timeInterval}
              setGenericState={setTimeInterval}
              labels={["1 Hour", "1 Week", "1 Month", "1 Year", "All time"]}
              modifier={""}
              selectName="1 Month"
            />
            <Dropdown
              genericState={postsAnalyzed}
              setGenericState={setPostsAnalyzed}
              labels={["100 posts", "500 posts", "1000 posts"]}
              modifier={"large"}
              selectName="1000 posts"
            />
          </div>
        </>
      )}
    </form>
  );
};

export default Search;
